import {SoopUiImg, SoopUiProfileIconMenu} from '@/components/ui';
import globalDomains from '@/utils/global-domains';
import {
  sendLegacyInflowPathLog,
  sendLiveThumbnailClickLog,
} from '@/utils/main/my/log';
import {useMemo, useRef, useState} from 'react';
import {getCategoryThumbUrl} from '@/utils/main';
import {DISPLAY_THUMBNAIL} from '@/constants/common/thumbnail';
import useGlobalUIStore from '@/stores';

/**
 * LIVE Component
 * @param {String} userId - 방송중인 유저 아이디
 * @param {String} userNick - 방송중인 유저 닉네임
 * @param {String} profileImage - 방송중인 유저 프로필 이미지
 * @param {Boolean} isPassword - 방송 비밀번호 여부
 * @param {Number} broadGrade - 방송 시청 등급
 * @param {Number} broadNo - 방송 번호
 * @param {String} broadTitle - 방송 제목
 * @param {String} thumb - 방송 썸네일
 * @param {Number} currentViewCnt - 현재 시청자 수
 * @returns
 */

// 방송국 새 글 라이브 방송 컴포넌트
const FeedLive = ({
  userId = '',
  userNick = '',
  profileImage = '',
  isPassword = false,
  broadGrade = 0,
  broadCateNo = '',
  broadNo = 0,
  broadTitle = '',
  thumb = '',
  currentViewCnt = 0,
}) => {
  const {isDarkMode} = useGlobalUIStore();

  const [imageError, setImageError] = useState(false);
  const soopUiProfileIconMenu = useRef(null);

  const link = `${globalDomains.PLAY_AFREECATV}/${userId}/${broadNo}`;

  const handleThumbnailClick = () => {
    // 방송 썸네일 클릭 로그
    sendLiveThumbnailClickLog({
      streamerId: userId,
      broadcastId: broadNo,
      // 아래 정보들은 백엔드에서 안내려줘서 주석처리(기존 실서버에서도 undefined로 넘어가는 값들이라서 주석처리함)
      // broadCateNo: undefined,
      // broadBps: undefined,
      // broadResolution: undefined,
    });
    // 기존에 사용하던 라이브 방송 유입 로그
    sendLegacyInflowPathLog({
      streamerId: userId,
      broadcastId: broadNo,
    });
  };

  const handleImageError = () => {
    setImageError(true);
    return;
  };

  const getDefaultThumbnail = ({isError}) => {
    if (isError) {
      return 'thumb-default';
    }
    return '';
  };

  // 썸네일 이미지, 비공개, 19금 일반, 이미지 에러시 default 이미지
  const thumbnailImage = useMemo(() => {
    let className = '';

    let thumbnailUrl = thumb;
    const isAdult = broadGrade >= 19;
    if (isAdult || isPassword) {
      thumbnailUrl = getCategoryThumbUrl(
        broadCateNo,
        DISPLAY_THUMBNAIL.HORIZONTAL,
        'live',
        isDarkMode,
      );
    }

    return (
      <a
        href={link}
        className={getDefaultThumbnail({isError: imageError})}
        target='_blank'
        onClick={handleThumbnailClick}>
        <span className='thum'>
          {!imageError ? (
            <SoopUiImg
              src={thumbnailUrl}
              onError={handleImageError}
              type={'thumbs'}
            />
          ) : null}
        </span>
        {isAdult && isPassword ? (
          <span className='status adult_lock'>연령제한+비밀번호</span>
        ) : isAdult ? (
          <span className='status adult'>연령제한</span>
        ) : isPassword ? (
          <span className='status lock'>비밀번호</span>
        ) : null}
        <p className='sbj' title=''>
          {broadTitle}
        </p>
        <span className='feed_live'>LIVE</span>
      </a>
    );
  }, [broadGrade, isPassword, thumb, broadTitle, userId, broadNo, isDarkMode]);

  return (
    <>
      <div className='list-item'>
        <div className='item-wrap'>
          <div className='autor_wrap'>
            <span className='thum'>
              <img src={profileImage} alt='프로필 이미지' />
            </span>
            <div className='info_box'>
              <button
                type='button'
                className='nick'
                onClick={() => {
                  soopUiProfileIconMenu.current?.open();
                }}>
                <p>{userNick}</p>
              </button>
              <span>{currentViewCnt}명 시청중</span>
              <SoopUiProfileIconMenu
                ref={soopUiProfileIconMenu}
                streamerId={userId}
                streamerNick={userNick}
              />
            </div>
          </div>

          <div className='onAir_box'>{thumbnailImage}</div>
        </div>
      </div>
    </>
  );
};

export default FeedLive;
